const pngErrorCodes = {
	"S120_1_6000":"网络异常，请稍后再试",
	"S120_1_6001":"请勿重复提交",
	"S120_1_6002":"已经存在变更申请，请等待审批结果",
	"S120_1_6003":"当前日指定不存在",
	"S120_1_6004":"无效变更，变更需求量不能等于批准量"
}
export default pngErrorCodes;